import { render, staticRenderFns } from "./SatelliteWishMap.vue?vue&type=template&id=89a5be7a&scoped=true&"
import script from "./SatelliteWishMap.vue?vue&type=script&lang=js&"
export * from "./SatelliteWishMap.vue?vue&type=script&lang=js&"
import style0 from "./SatelliteWishMap.vue?vue&type=style&index=0&id=89a5be7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a5be7a",
  null
  
)

export default component.exports